import React from 'react';

const initialState = {
   open: false,
   children: null,
   extraProps: {}
};

const sliceConfig = {
   name: 'sidebar',
   initialState: initialState,
   reducers: {
      close(state) {
         state.open = initialState.open;
         state.children = initialState.children;
         state.extraProps = initialState.extraProps;
      },
      open(state, action) {
         state.open = true;
         state.children = action.payload.children;
         state.extraProps = action.payload.extraProps;
      }
   }
};

const Close = 'sidebar/close';
const Open = 'sidebar/open';
const OpenMsg = 'msg/open';

export function open(Component, componentProps = {}, callbackOnClose = null, containerProps = {}) {
   return async function (dispatch) {
      const {open, onClose, children, ...options} = containerProps;
      async function handleCloseModalCallback(data) {
         try {
            if (callbackOnClose) {
               await callbackOnClose(data);
               //dispatch(closeSidebar());
               dispatch({type: Close});
            } else {
               dispatch({type: Close});
            }
         } catch (error) {
            dispatch({
               type: OpenMsg,
               payload: {
                  mensaje: payload.mensaje,
                  accionAceptar: payload.accionAceptar,
                  aceptarLabel: payload.aceptarLabel
               }
            });
         }
      }
      function handleOnClose() {
         dispatch({
            type: Close
         });
      }
      dispatch({
         type: Open,
         payload: {
            extraProps: {
               ...options,
               onClose: handleOnClose
            },
            children: (
               <Component
                  closeModalCallback={handleCloseModalCallback}
                  closeModal={handleOnClose}
                  {...componentProps}
               />
            )
         }
      });
   };
}

export default sliceConfig;
